import apiClient from './client';

export interface DeviceSummary {
  id: string;
  name: string;
  description?: string;
  platform: string;
  status: string;
  mesh_ip?: string;
  can_route_traffic: boolean;
  can_accept_routes: boolean;
  last_seen_at?: string;
  paired_at?: string;
  created_at: string;
}

export interface DeviceRegisterRequest {
  name: string;
  description?: string;
  platform: string;
}

export interface DeviceRegisterResponse {
  device_id: string;
  pairing_code: string;
  expires_at?: string;
}

export interface DevicePairRequest {
  pairing_code: string;
  public_key: string;
}

export interface DevicePairResponse {
  device: DeviceSummary;
  device_token: string;
}

export interface DeviceHeartbeatPayload {
  external_ip?: string;
  external_port?: number;
  nat_type?: string;
  can_route_traffic?: boolean;
  can_accept_routes?: boolean;
}

export interface DeviceListResponse {
  devices: DeviceSummary[];
}

export interface SharedDeviceEntry {
  device: DeviceSummary;
  owner_id: string;
  permission_id: string;
  status: string;
}

export interface SharedDevicesResponse {
  shared_devices: SharedDeviceEntry[];
}

export interface DeviceGrantRequest {
  friend_user_id: string;
  notes?: string;
}

export interface DevicePermissionResponse {
  id: string;
  device_id: string;
  owner_id: string;
  grantee_user_id: string;
  status: string;
  notes?: string;
  created_at: string;
  updated_at: string;
  revoked_at?: string;
}

export const devicesApi = {
  listOwned: () => apiClient.get<DeviceListResponse>('/api/v1/devices'),
  listShared: () => apiClient.get<SharedDevicesResponse>('/api/v1/devices/shared-with-me'),
  register: (payload: DeviceRegisterRequest) =>
    apiClient.post<DeviceRegisterResponse>('/api/v1/devices/register', payload),
  pair: (deviceId: string, payload: DevicePairRequest) =>
    apiClient.post<DevicePairResponse>(`/api/v1/devices/${deviceId}/pair`, payload),
  heartbeatOwner: (deviceId: string, payload: DeviceHeartbeatPayload) =>
    apiClient.post(`/api/v1/devices/${deviceId}/heartbeat`, payload),
  heartbeatDevice: (payload: DeviceHeartbeatPayload, token: string) =>
    apiClient.post('/api/v1/devices/me/heartbeat', payload, {
      headers: { 'X-Device-Token': token },
    }),
  grant: (deviceId: string, payload: DeviceGrantRequest) =>
    apiClient.post<DevicePermissionResponse>(`/api/v1/devices/${deviceId}/grants`, payload),
  revoke: (permissionId: string) =>
    apiClient.delete<DevicePermissionResponse>(`/api/v1/devices/grants/${permissionId}`),
};
